import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";
import ModuleQuestion from "../../components/ModuleQuestion";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">3.0.4 Case 4</h1>
            <p className="me-4">Estimated time to complete: 3-5 minutes</p>
          </section>
          <ModuleQuestion
            correctAnswer="B"
            assessmentName="self_assessment_104"
            videoTranscript={
              <>
                <p>
                  <strong>AUDIO</strong>
                  <br />
                  VO: (FEMALE)
                  <br />
                  This is self-assessment case 104. This is a negative case.
                  I’ve started here at the level of the cerebellum and will
                  review the slices one by one. As we proceed up, we have now
                  entered the occipital lobe and temporal lobe. You will notice
                  that there is image noise, and yet you can see the delineation
                  of the white-matter tracts. Here and here, the delineation is
                  not clear, but the lack of clarity of the white-matter tracts
                  is due to noise, not decreased contrast, as you can see
                  through here. As you go up, you continue to see the suggestion
                  of the white-matter tracts and actually very low counts in the
                  surrounding gray matter. The delineation of the white-matter
                  tracts is made more difficult by the noise, but there are no
                  slices that indicate that there is gray matter uptake that
                  causes decreased contrast. The same phenomenon is happening in
                  the frontal cortices where you have areas of increased uptake
                  in the area of white-matter tracts And yet because of image
                  noise, there are breaks, and it is hard to see them as one
                  consistent structure. Again, as you go further up to the
                  parietal cortex, you see the suggestion of the white-matter
                  tracts on some slices, and yet more difficult on others
                  because of the image noise. At no point do you have a
                  suggestion that you have decreased gray-white contrast. Image
                  noise such as this can be caused by lower counts in the brain.
                  Given the fact that this is a negative case, the Florbetapir
                  likely washed out of the brain leaving a small amount of
                  counts in the brain to form the image. And yet, you can
                  clearly see that the white-matter tracts are present and the
                  gray matter has lower counts. If you called this positive, it
                  might be useful to go back and review the case on the MIMcloud
                  Viewer to better see this for yourself.
                </p>
              </>
            }
            previousLesson="/module-3/module-3-0-3"
            nextLesson="/module-3/module-3-0-5"
            iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_668208681&entry_id=1_l7an2m4w&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
            questionType="assessment"
            videoId="1_l7an2m4w"
          />
        </main>
      </div>
    </div>
  );
};

export default Module_1_0;
